import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type { BonusModel } from "../../types/BonusModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.BONUS_DATA}`;

export interface Values {
	loading: boolean;

	bonuses: BonusModel[];
}

export const initialState: IStateProps<Values> = {
	loading: false,

	bonuses: []
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
